module.exports = "/images/vendor/flag-icon-css/flags/4x3/hk.svg?7428ec1c480645e3654a2729c9f6e07f";